import { FC, useState } from 'react';
import { PreviewIframe } from '../../atoms/PreviewIframe/PreviewIframe';
import './CustomTagListTable.scss';
import { CustomTagInfo } from '../../types/customtag';
import SelectBox from '../../atoms/Select/Select';
import { useGetCustomTagContent } from '../../hooks/useGetCustomTagContent/useGetCustomTagContent';
import { useNavigate } from 'react-router-dom';
import { Pagination } from '../../types/campaign';

export interface CustomTagListInfo {
  customTagList?: CustomTagInfo[];
  setPagination: (pagination: Pagination) => void;
}

export const CustomTagListTable: FC<CustomTagListInfo> = ({
  customTagList,
  setPagination,
}) => {
  const navigate = useNavigate();
  const [isPreviewOpen, setPreviewOpen] = useState(false);
  // const [customTag, setCustomTag] = useState<CustomTag>();
  const { mutate: getTagContent, data: tagContent } = useGetCustomTagContent();

  const openPreview = (tagId: string, version: number) => {
    setPreviewOpen(true);
    getTagContent({
      tagId: tagId,
      version: version,
    });
  };

  const closePreview = () => {
    setPreviewOpen(false);
  };
  const renderPreviewOverlay = () => {
    return (
      <div className="preview-overlay">
        <div className="preview-content">
          {/* Add the PreviewIframe component here */}

          <div className="closePreview">
            <div onClick={closePreview}>x</div>
          </div>

          <PreviewIframe
            // htmlCode={tagContent ? [tagContent.htmlContent] : []}
            // cssCode={tagContent ? [tagContent.cssContent] : []}
            campaignPages={[
              {
                name: '',
                content:
                  tagContent && tagContent.htmlContent
                    ? tagContent.htmlContent
                    : '',
                cssContent:
                  tagContent && tagContent.cssContent
                    ? tagContent.cssContent
                    : '',
                orientation: '',
                index: 0,
                active: false,
              },
            ]}
          />
        </div>
      </div>
    );
  };

  return (
    <div className="customTagListTable-container">
      {customTagList &&
        customTagList.length > 0 &&
        customTagList.map((customTag, index) => (
          <div className="content" key={`customtag_${index}`}>
            <div className="flex-display">
              <div className="left-text tag-name">{customTag.tagName}</div>
              <div className="middle-text">{customTag.tagId}</div>
            </div>

            <div className="middle-text">{customTag.description}</div>
            <div className="middle-text">
              {customTag.createdDateStr ? customTag.createdDateStr : ''}
            </div>
            <div className="middle-text">{customTag.currentVersion}</div>
            <div className="middle-text">
              <SelectBox
                name={'versionList'}
                id={'versionList'}
                list={customTag.versionsList.map(version => {
                  return {
                    value: version,
                    label: version + '',
                  };
                })}
                width={'60%'}
              />
            </div>
            <div className="right-buttons">
              <button
                className="eye"
                onClick={() =>
                  openPreview(customTag.tagId, customTag.currentVersion)
                }
              >
                👁️
              </button>

              <div className="flex-displays">
                <div className="edit-button">
                  <svg
                    width="18"
                    height="18"
                    viewBox="0 0 18 18"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                    onClick={() => {
                      navigate(`/customtag?tag=${customTag.tagId}`);
                    }}
                  >
                    <path
                      d="M12.9428 0.895104C13.2145 0.614718 13.5392 0.391189 13.8982 0.237532C14.2571 0.0838748 14.643 0.00316129 15.0334 9.1018e-05C15.4238 -0.00297925 15.811 0.0716551 16.1723 0.219648C16.5336 0.367641 16.8618 0.586035 17.1379 0.862114C17.414 1.13819 17.6324 1.46644 17.7804 1.82774C17.9283 2.18903 18.003 2.57617 17.9999 2.96659C17.9968 3.35701 17.9161 3.74292 17.7625 4.10184C17.6088 4.46077 17.3853 4.78554 17.1049 5.05724L15.9521 6.21007L11.7899 2.04793L12.9428 0.895104ZM10.9964 2.84143L1.87341 11.9644C1.54404 12.2938 1.30449 12.7026 1.17873 13.1517L0.0206641 17.2876C-0.00609255 17.3835 -0.00687888 17.4848 0.0183856 17.5811C0.0436502 17.6773 0.0940571 17.7652 0.164442 17.8356C0.234826 17.9059 0.322658 17.9564 0.418938 17.9816C0.515217 18.0069 0.616482 18.0061 0.712358 17.9793L4.84755 16.8213C5.29665 16.6956 5.7058 16.4564 6.03555 16.1266L15.1593 7.00432L10.9972 2.84218L10.9964 2.84143Z"
                      fill="#00580A"
                    />
                  </svg>
                </div>

                {/* <div className="delete-button">
                  <svg
                    width="16"
                    height="18"
                    viewBox="0 0 16 18"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M3 18C2.45 18 1.979 17.804 1.587 17.412C1.195 17.02 0.999333 16.5493 1 16V3H0V1H5V0H11V1H16V3H15V16C15 16.55 14.804 17.021 14.412 17.413C14.02 17.805 13.5493 18.0007 13 18H3ZM5 14H7V5H5V14ZM9 14H11V5H9V14Z"
                      fill="#00580A"
                    />
                  </svg>
                </div> */}
              </div>
            </div>
          </div>
        ))}
      {isPreviewOpen && renderPreviewOverlay()}
    </div>
  );
};
